import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetosomnathjyotilingacabserv() {



const cardData = {
  keyword: "Pune to Somnath Jyotirlinga Cab Service ",

"headingDescription": "SRS Cab Service offers Pune to Somnath Jyotirlinga Cab Service, providing a comfortable, safe, and reliable travel option for pilgrims, families, and spiritual travelers. Our professional drivers, well-maintained vehicles, and timely pickups ensure a smooth and hassle-free journey from Pune to Somnath. Ideal for devotional trips, sightseeing, and group travel, SRS Cab Service provides flexible booking, transparent pricing, and 24/7 customer support for a worry-free pilgrimage experience.",
"topPlaces": [
  {
    "title": "Somnath Jyotirlinga Temple",
    "description": "The Somnath Jyotirlinga Temple is one of the twelve sacred Jyotirlingas of Lord Shiva. Travelers using SRS Cab Service from Pune often visit this temple for prayers, spiritual rituals, and to experience the temple’s divine atmosphere."
  },
  {
    "title": "Bhalka Tirth",
    "description": "Bhalka Tirth is the site where Lord Krishna is believed to have been struck by an arrow. Visitors traveling with SRS Cab Service often stop here to witness this important spiritual landmark."
  },
  {
    "title": "Triveni Sangam",
    "description": "Triveni Sangam is the confluence of three rivers near Somnath. Travelers using SRS Cab Service often visit this serene location for rituals and to enjoy the peaceful river views."
  },
  {
    "title": "Gir National Park",
    "description": "Gir National Park is a wildlife sanctuary famous for Asiatic lions. Visitors using SRS Cab Service often include this park in their itinerary for sightseeing and nature experiences."
  },
  {
    "title": "Somnath Beach",
    "description": "Somnath Beach is a scenic coastal area near the temple. Travelers using SRS Cab Service often relax here, enjoy sunsets, and take photographs of the Arabian Sea."
  },
  {
    "title": "Prabhas Patan Museum",
    "description": "Prabhas Patan Museum showcases historical artifacts and temple-related exhibits. Travelers using SRS Cab Service often visit to learn about Somnath’s rich cultural heritage."
  },
  {
    "title": "Archaeological Site of Somnath",
    "description": "The archaeological site near Somnath Temple preserves remnants of older temples. Visitors traveling with SRS Cab Service often explore this site to understand the temple’s historic significance."
  },
  {
    "title": "Jyotirlinga Shopping Complex",
    "description": "Jyotirlinga Shopping Complex offers souvenirs, religious items, and local handicrafts. Travelers using SRS Cab Service often shop here for mementos of their pilgrimage."
  },
  {
    "title": "Somnath Light and Sound Show",
    "description": "The Light and Sound Show at Somnath Temple narrates the temple’s history and legends. Visitors using SRS Cab Service often attend this show in the evening for an immersive experience."
  },
  {
    "title": "Bhalka Beach",
    "description": "Bhalka Beach is a calm coastal area near Bhalka Tirth. Travelers using SRS Cab Service often visit for peace, meditation, and to enjoy the coastal scenery."
  }
],



services: [
{
name: "Pune to Somnath Jyotirlinga Cab Service",
description: "Pune to Somnath Jyotirlinga cab service offers reliable long-distance pilgrimage travel. Customers can book cabs for spiritual journeys to Somnath temple. Professional drivers ensure safe highway travel. Comfortable vehicles enhance long-distance experience. Flexible booking options are available. Travel easily with Jyotirlinga cab services from Pune."
},
{
name: "Pune to Somnath Cab",
description: "Pune to Somnath cab provides convenient transportation for long-distance travel. Customers can book cabs for pilgrimage and tourism trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily from Pune to Somnath with cab services."
},
{
name: "Pune to Somnath Taxi",
description: "Pune to Somnath taxi offers reliable transportation for extended journeys. Customers can book taxis for flexible travel plans. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with taxi services from Pune."
},
{
name: "Pune to Somnath Cab Service",
description: "Pune to Somnath cab service provides dependable travel for intercity journeys. Customers can book cabs for one-way or round trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Choose cab services for Pune to Somnath travel."
},
{
name: "Pune to Somnath Taxi Service",
description: "Pune to Somnath taxi service offers convenient travel for pilgrimage trips. Customers can book taxis for long-distance journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services from Pune."
},
{
name: "Pune to Somnath Cab Booking",
description: "Pune to Somnath cab booking provides quick and easy reservation options. Customers can book cabs online or via mobile apps. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your Pune to Somnath cab easily."
},
{
name: "Pune to Somnath Taxi Booking",
description: "Pune to Somnath taxi booking offers convenient booking options for travelers. Customers can reserve taxis instantly online. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your taxi from Pune to Somnath easily."
},
{
name: "Pune to Somnath One Way Cab",
description: "Pune to Somnath one way cab offers economical travel without return charges. Customers can book direct rides easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Choose one-way cab services for Pune to Somnath."
},
{
name: "Pune to Somnath One Way Taxi",
description: "Pune to Somnath one way taxi provides convenient travel for single-direction journeys. Customers can book taxis easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one-way taxi services."
},
{
name: "Pune to Somnath Cab Fare",
description: "Pune to Somnath cab fare provides detailed pricing for travel planning. Customers can compare fares before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel confidently with cab fare services."
},
{
name: "Pune to Somnath Taxi Price",
description: "Pune to Somnath taxi price offers clear pricing details for travelers. Customers can check rates before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose taxi services with transparent pricing."
},
{
name: "Pune to Somnath Cab Hire",
description: "Pune to Somnath cab hire offers flexible travel solutions for long-distance trips. Customers can hire vehicles for personal and pilgrimage travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Hire cabs from Pune to Somnath easily."
},
{
name: "Pune to Somnath Taxi Hire",
description: "Pune to Somnath taxi hire provides convenient transportation for long journeys. Customers can hire taxis for flexible schedules. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Choose taxi hire services easily."
},
{
name: "Pune to Somnath Outstation Cab",
description: "Pune to Somnath outstation cab offers reliable travel for long-distance trips. Customers can book cabs for one-way or round journeys. Professional drivers ensure safe highway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with outstation cab services."
},
{
name: "Pune to Somnath Outstation Taxi",
description: "Pune to Somnath outstation taxi provides dependable travel for extended journeys. Customers can book taxis for flexible travel plans. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with outstation taxi services."
},
{
name: "Pune to Somnath Darshan Cab",
description: "Pune to Somnath darshan cab offers spiritual travel for temple visits. Customers can book cabs for pilgrimage trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily for darshan from Pune."
},
{
name: "Pune to Somnath Jyotirlinga Taxi",
description: "Pune to Somnath Jyotirlinga taxi provides convenient travel for devotees. Customers can visit the sacred temple comfortably. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with Jyotirlinga taxi services."
},
{
name: "Pune to Somnath Cab Online Booking",
description: "Pune to Somnath cab online booking offers instant reservation options. Customers can book cabs digitally with ease. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab online from Pune."
},
{
name: "Pune to Somnath Taxi Online Booking",
description: "Pune to Somnath taxi online booking provides quick and convenient booking services. Customers can reserve taxis instantly online. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your taxi online easily."
},
{
name: "Pune to Somnath Long Distance Cab",
description: "Pune to Somnath long distance cab offers reliable travel for extended journeys. Customers can book cabs for multi-day trips. Professional drivers ensure safe highway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with long-distance cab services."
},
{
name: "Innova Cab Pune to Somnath",
description: "Innova cab Pune to Somnath offers premium SUV travel for long journeys. Customers can enjoy spacious seating and comfort. Professional drivers ensure safe travel. Ideal for family trips. Transparent pricing ensures value for money. Travel comfortably with Innova cab services."
},
{
name: "Innova Crysta Cab Pune to Somnath",
description: "Innova Crysta cab Pune to Somnath provides luxury travel with premium comfort. Customers can enjoy spacious seating and smooth rides. Professional drivers ensure safe travel. Ideal for group journeys. Transparent pricing ensures value for money. Travel easily with Innova Crysta services."
},
{
name: "Ertiga Cab Pune to Somnath",
description: "Ertiga cab Pune to Somnath offers comfortable 7-seater travel for families. Customers can enjoy smooth long-distance journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Ertiga cab services."
},
{
name: "Dzire Cab Pune to Somnath",
description: "Dzire cab Pune to Somnath provides economical travel for long-distance trips. Customers can book sedans for budget-friendly journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Transparent pricing ensures affordability. Travel easily with Dzire cab services."
},
{
name: "Sedan Cab Pune to Somnath",
description: "Sedan cab Pune to Somnath offers cost-effective travel for individuals and small groups. Customers can book vehicles for comfortable journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with sedan cab services."
},
{
name: "SUV Cab Pune to Somnath",
description: "SUV cab Pune to Somnath provides spacious travel for long-distance trips. Customers can enjoy comfortable seating and luggage space. Professional drivers ensure safe travel. Ideal for family and group journeys. Flexible booking options are available. Travel easily with SUV cab services."
},
{
name: "Luxury Cab Pune to Somnath",
description: "Luxury cab Pune to Somnath offers premium travel experience for long journeys. Customers can enjoy high-end vehicles with extra comfort. Professional drivers ensure safe travel. Ideal for corporate and VIP travel. Flexible booking options are available. Travel comfortably with luxury cab services."
},
{
name: "Tempo Traveller Pune to Somnath",
description: "Tempo traveller Pune to Somnath offers group travel solutions for long-distance trips. Customers can book spacious vehicles for families and groups. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with tempo traveller services."
},
{
name: "Urbania on Rent Pune to Somnath",
description: "Urbania on rent Pune to Somnath offers premium group travel with luxury comfort. Customers can book vehicles for long-distance trips. Professional drivers ensure safe journeys. Spacious seating enhances experience. Flexible booking options are available. Travel easily with Urbania services."
},
{
name: "Pune to 12 Jyotirlinga Darshan Package",
description: "Pune to 12 Jyotirlinga darshan package offers complete spiritual travel across India. Customers can visit all Jyotirlingas comfortably. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book Jyotirlinga packages from Pune easily."
},
{
name: "12 Jyotirlinga Tour from Pune",
description: "12 Jyotirlinga tour from Pune provides organized travel for devotees. Customers can explore all sacred temples in one trip. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with Jyotirlinga tour packages."
},
{
name: "Jyotirlinga Tour Package Pune",
description: "Jyotirlinga tour package Pune offers complete pilgrimage travel solutions. Customers can visit multiple temples comfortably. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Choose Jyotirlinga packages from Pune."
},
{
name: "Pune to 12 Jyotirlinga Yatra Package",
description: "Pune to 12 Jyotirlinga yatra package provides spiritual travel for devotees. Customers can complete sacred journeys easily. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Book your Jyotirlinga yatra from Pune."
}
],

tableData: [
["Pune to Somnath Jyotirlinga Cab Service","Pune to Somnath Cab"],
["Pune to Somnath Taxi","Pune to Somnath Cab Service"],
["Pune to Somnath Taxi Service","Pune to Somnath Cab Booking"],
["Pune to Somnath Taxi Booking","Pune to Somnath One Way Cab"],
["Pune to Somnath One Way Taxi","Pune to Somnath Cab Fare"],
["Pune to Somnath Taxi Price","Pune to Somnath Cab Hire"],
["Pune to Somnath Taxi Hire","Pune to Somnath Outstation Cab"],
["Pune to Somnath Outstation Taxi","Pune to Somnath Darshan Cab"],
["Pune to Somnath Jyotirlinga Taxi","Pune to Somnath Cab Online Booking"],
["Pune to Somnath Taxi Online Booking","Pune to Somnath Long Distance Cab"],
["Innova Cab Pune to Somnath","Innova Crysta Cab Pune to Somnath"],
["Ertiga Cab Pune to Somnath","Dzire Cab Pune to Somnath"],
["Sedan Cab Pune to Somnath","SUV Cab Pune to Somnath"],
["Luxury Cab Pune to Somnath","Tempo Traveller Pune to Somnath"],
["Urbania on Rent Pune to Somnath","Pune to 12 Jyotirlinga Darshan Package"],
["12 Jyotirlinga Tour from Pune","Jyotirlinga Tour Package Pune"],
["Pune to 12 Jyotirlinga Yatra Package","Pune to Somnath Cab"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Pilgrimage Route Drivers",
    WhyChoosedescription: "SRS Cab Service provides skilled drivers experienced in long-distance pilgrimage routes like Pune to Somnath Jyotirlinga, ensuring safe driving and smooth intercity travel."
  },
  {
    WhyChooseheading: "Affordable Somnath Cab Package Pricing",
    WhyChoosedescription: "We offer budget-friendly Pune to Somnath cab services with transparent pricing. Customers receive complete fare details including tolls, state taxes, and driver allowance with no hidden charges."
  },
  {
    WhyChooseheading: "Customized Multi-Day Pilgrimage Tours",
    WhyChoosedescription: "SRS Cab Service offers flexible travel plans for Pune to Somnath Jyotirlinga including multi-day packages with optional stops at Dwarka and other holy destinations."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Pune to Somnath cab service operates 24/7, making it convenient for long-distance spiritual journeys and flexible departure timings."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles for Long Travel",
    WhyChoosedescription: "We provide clean, well-maintained, and air-conditioned vehicles designed for long-distance comfort, ensuring a peaceful journey to Somnath."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers suitable for family and group pilgrimage tours."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "We offer convenient pickup from homes, hotels, offices, and Pune Airport across all major areas including Hinjewadi, Wakad, Baner, and Hadapsar."
  },
  {
    WhyChooseheading: "Trusted Jyotirlinga Tour Cab Service",
    WhyChoosedescription: "SRS Cab Service is trusted for Pune to Somnath Jyotirlinga cab bookings due to reliable service, experienced drivers, and smooth long-distance travel experience."
  }
]
}

const faqData = [
  { question: "Do you provide Pune to Somnath Jyotirlinga cab service?", answer: "Yes, SRS Cab Service offers reliable cab services from Pune to Somnath Jyotirlinga." },
  { question: "How far is Somnath from Pune?", answer: "The distance between Pune and Somnath is approximately 900 km and the journey takes around 16 to 18 hours depending on route and traffic." },
  { question: "How many days are required for Somnath trip?", answer: "Typically, a 3 to 5-day trip is recommended for Pune to Somnath Jyotirlinga tour." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 for flexible travel planning." },
  { question: "Which vehicles are available for Somnath travel?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, luxury Innova Crysta, and Tempo Travellers." },
  { question: "Can I customize my Somnath tour package?", answer: "Yes, we provide fully customizable travel plans including Dwarka and other pilgrimage destinations." },
  { question: "Are vehicles suitable for long-distance travel?", answer: "Yes, all vehicles are well-maintained and suitable for long-distance journeys." },
  { question: "Can I book the cab online?", answer: "Yes, you can easily book Pune to Somnath cab service online or via phone." },
  { question: "Do you provide pickup from Pune home or hotel?", answer: "Yes, we provide doorstep pickup from homes, hotels, offices, and Pune Airport." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rajesh Patel",
    feedback:
      "Booked SRS Cab Service for Somnath Jyotirlinga trip. Long journey was very smooth and driver was very professional.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Meena Sharma",
    feedback:
      "Excellent Pune to Somnath cab service. Comfortable ride and perfect for family pilgrimage.",
    rating: 5
  }
];































const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Somnath Jyotirlinga Cab Service | SRS Cab",
  "description": "SRS Cab provides Pune to Somnath Jyotirlinga cab services including one-way and round trips, taxi booking, and long-distance outstation travel. Choose from Innova Crysta, Ertiga, Dzire, Sedan, SUV, Tempo Traveller, and Urbania rentals. Book safe, comfortable, and affordable Somnath Darshan and 12 Jyotirlinga tour packages with 24x7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "SRS Cab"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.srscabservice.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};





  return (
    <div>
      

<Helmet>
  <title>Pune to Somnath Jyotirlinga Cab Service | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book Pune to Somnath Jyotirlinga cab service with SRS Cab. One-way, round trips, taxi booking, and long-distance travel with Innova, Ertiga, Dzire, SUV, Tempo Traveller, and Urbania. Affordable Somnath Darshan and 12 Jyotirlinga tour packages with 24x7 online booking." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/35.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetosomnathjyotilingacabserv;